import { SxProps } from "@mui/material";
import colors from "../../../theme/Colours";

const CreditNotesTableStyles: Record<string, SxProps> = {
  tableContainer: {
    boxShadow: "none",
  },
  headerText: {
    fontWeight: 500,
    fontSize: "12px",
    color: "#667085",
  },
  headerIcon: {
    width: 12,
    height: 12,
    cursor: "pointer",
  },

  cellCustomerName: {
    color: "#101828",
    fontWeight: 500,
  },
  cellDefault: {
    color: colors.tableFieldText,
  },
  totalLabel: {
    fontWeight: "bold",
    fontSize: "14px",
    color: colors.primaryButtonOrange,
  },
  totalValue: {
    fontWeight: "bold",
    fontSize: "14px",
    color: colors.creditNoteTotalPositive,
  },
};

export default CreditNotesTableStyles;
